module.exports = __webpack_public_path__ + "static/profile-active-d1b419d7ecf620f252dd06fcb77cafa2.svg";